import { noop } from 'lodash-es';

export interface AuthToken {
  accessToken: string;
  expiry: string;
  refreshToken: string;
}

export interface AuthTokenStorage {
  retrieveToken: () => AuthToken | undefined;
  storeToken: (value: AuthToken) => void;
  removeToken: () => void;
}

export const AUTH_TOKEN_STORAGE_PREFIX = 'viam.auth.tkn';

export const NOOP_STORAGE: AuthTokenStorage = {
  // TODO: Anyway to use noop with a return?
  retrieveToken: () => undefined,
  storeToken: noop,
  removeToken: noop,
};

export const createTokenStorage = (clientID: string): AuthTokenStorage => {
  if (typeof window === 'undefined') {
    return NOOP_STORAGE;
  }

  const key = `${AUTH_TOKEN_STORAGE_PREFIX}.${clientID}`;

  const retrieveToken = () => {
    const value = localStorage.getItem(key);
    if (!value) {
      return undefined;
    }

    return JSON.parse(value) as AuthToken;
  };

  const storeToken = (value: AuthToken) =>
    localStorage.setItem(key, JSON.stringify(value));

  const removeToken = () => localStorage.removeItem(key);

  return { retrieveToken, storeToken, removeToken };
};
